import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addcharges',
  templateUrl: './addcharges.component.html',
  styleUrls: ['./addcharges.component.css']
})
export class AddchargesComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  chargesColl: any = [];
  methodofcalcColl: any = [];

  tablesectionColl: any = [];

  ordermodeColl: any = [];

  chargesform = new FormGroup({
    chargesid: new FormControl(0),
    chargesname: new FormControl('', Validators.required),
    chargesrate: new FormControl(null),
    chargesamt: new FormControl(null),
    description: new FormControl(''),
    isdinein: new FormControl(false),
    istakeaway: new FormControl(false),
    isdelivery: new FormControl(false),
    methodofcalc: new FormControl(''),
    isonline: new FormControl(false),
    inactive: new FormControl(false),
    tablesectionid: new FormControl(null),
    ordermodeid: new FormControl(null),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Charges";

  chargestype: String = "rate";

  @Input() chargesid: number = 0
  @Input() chargesname: any = '';
  @Output() emitData = new EventEmitter();

  currencyMask:any="";

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.chargesid = params.id
      }
    });
    this.fnServiceChanges();

    this.currencyMask=this.loginService.fngetDecimalPlaces()
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.chargesform.reset();
      this.fnInitializeCharges();

      if (this.chargesid > 0) {
        this.fngetCharges();
      }

      this.fngetTablesection();
      this.fngetOrdermode();

      this.fngetMethodofCalc();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.chargesid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeCharges() {
    this.chargesform.setValue({

      chargesid: 0,
      chargesname: '',
      chargesrate: null,
      chargesamt: null,
      description: '',
      isdinein: false,
      istakeaway: false,
      isdelivery: false,
      methodofcalc: '',
      isonline: false,
      tablesectionid: null,
      ordermodeid: null,
      inactive: false,
    })
  }
  fngetMethodofCalc() {
    this.methodofcalcColl = [];
    this.methodofcalcColl.push({ value: 'ONTAX', displayname: 'ON TAX' });
    this.methodofcalcColl.push({ value: 'ONAMOUNT', displayname: 'ON AMOUNT' });
  }

  fngetTablesection() {

    var data = {
      'tablesectionid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getTableSection(data)
      .subscribe(
        (res) => {
          this.tablesectionColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetOrdermode() {

    var data = {
      'ordermodeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getOrdermode(data)
      .subscribe(
        (res) => {
          this.ordermodeColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetCharges() {

    var data = {
      'chargesid': this.chargesid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getCharges(data)
      .subscribe(
        (res) => {
          this.chargesColl = res.json().result;
          var editdata = this.chargesColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.chargesform.valid) {
        this.saveloading = true

        if (this.chargestype === 'rate') {
          this.chargesform.patchValue({ 'chargesamt': 0 })
        }
        else if (this.chargestype === 'amount') {
          this.chargesform.patchValue({ 'chargesrate': 0 })
        }

        //Check
        var data = {
          'chargesid': this.chargesid,
          'chargesname': this.chargesform.get('chargesname').value,
          'chargesrate': this.chargesform.get('chargesrate').value,
          'chargesamt': this.chargesform.get('chargesamt').value,
          'description': this.chargesform.get('description').value,
          'isdinein': this.chargesform.get('isdinein').value,
          'istakeaway': this.chargesform.get('istakeaway').value,
          'isdelivery': this.chargesform.get('isdelivery').value,
          'methodofcalc': this.chargesform.get('methodofcalc').value,
          'isonline': this.chargesform.get('isonline').value,
          'tablesectionid': this.chargesform.get('tablesectionid').value,
          'ordermodeid': this.chargesform.get('ordermodeid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.chargesform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckCharges(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.chargesform.get('chargesid').value > 0) {
                //Update Department
                this.fnSetCharges(data);
              }
              else {
                //Insert Department
                this.fnInsertCharges(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false

                this.chargesform.controls['chargesname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertCharges(data) {

    this.appService.fnInsertCharges(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnchargesid = 0;
          if (result.length > 0) {
            rtnchargesid = result[0].chargesid

          }
          this.toastr.success('', "The new Charges has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.chargesid);

          this.emitData.emit(rtnchargesid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetCharges(data) {

    this.appService.fnSetCharges(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().result != "") {
          this.toastr.success('', "The Charges has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.chargesid, data.chargesname);

          this.emitData.emit(this.chargesid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.chargesform.setValue({

      chargesid: deptBO.chargesid,
      chargesname: deptBO.chargesname,
      chargesrate: deptBO.chargesrate,
      chargesamt: deptBO.chargesamt,
      description: deptBO.description,
      isdinein: deptBO.isdinein,
      istakeaway: deptBO.istakeaway,
      isdelivery: deptBO.isdelivery,
      methodofcalc: deptBO.methodofcalc,
      isonline: deptBO.isonline,
      tablesectionid: deptBO.tablesectionid,
      ordermodeid: deptBO.ordermodeid,
      inactive: deptBO.inactive,
    });



    if (this.chargesform.get('chargesrate').value > 0) {
      this.chargestype = 'rate'
    }
    else if (this.chargesform.get('chargesamt').value > 0) {
      this.chargestype = 'amount'
    }



    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
